import React from 'react'
import '../../../src/components/containers/container.css'

const LayoutComponent = ({ children }) => {
    return (
        <div className='layout'>
            {/* <div className='layoutLogo'></div> */}
            {children}
        </div>
    )
}

export default LayoutComponent